export const RECEIVE_PRODUCT_TYPE = 'RECEIVE_PRODUCT_TYPE';
